import { Component, Input } from '@angular/core';

import { Type, DropdownDirection } from './constants';

@Component({
    selector: 'fc-dropdown-menu',
    templateUrl: './dropdown-menu.component.html',
    standalone: false
})
export class DropdownMenuComponent {
    @Input() public type: Type;
    @Input() public direction: DropdownDirection;

    public get typeName(): Type {
        return this.type || Type.Default;
    }

    get dropdownDirection() {
        return this.direction || DropdownDirection.Down;
    }
}
